import React from 'react'
import * as Styled from './M012.styles'

const NavCard = ({ image, name, type, linkUrl, onLinkClick, dataTest, index }) => {
  const target = type === 'external' ? '_blank' : '_self'
  const gutterValue = type === 'Sub-Heading' ? 0 : 1
  const lastWordIdx = name.lastIndexOf(' ')
  const lastWord = name.substring(lastWordIdx, name.length).trim()
  const nameWithoutLastWord = name.substring(0, lastWordIdx + 1)

  const onLinkClickFn = (e) => (typeof onLinkClick === 'function' ? onLinkClick(e, linkUrl, type) : false)

  return (
    <Styled.NavCardContainer
      forwardedAs='a'
      xs={12}
      sm={6}
      md={6}
      data-test={`${dataTest}-navCard-container-${index}`}
      onClick={onLinkClickFn}
      href={linkUrl}
      target={target}
      title={name}
      gutterSize='30px'
      gutterValue={gutterValue}
      numberOfColumns={12}
    >
      <Styled.NavLink data-test={`${dataTest}-navCard-name`}>
        {nameWithoutLastWord}
        <Styled.NavLinkLastWord>
          {lastWord}
          <Styled.Chevron data-test={`${dataTest}-navCard-chevron`} dir='right' />
        </Styled.NavLinkLastWord>
      </Styled.NavLink>
      <Styled.NavCardImage image={image} data-test={`${dataTest}-navCard-image`} />
    </Styled.NavCardContainer>
  )
}

export default NavCard
